import {Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FileUpload} from 'primeng/fileupload';

@Component({
    selector: 'app-upload-form',
    templateUrl: './upload-form.component.html',
    styleUrls: ['./upload-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UploadFormComponent {

    disallowedContentTypes = [
        "application/octet-stream",
        "application/vnd.microsoft.portable-executable",
    ];

    maxFileSize: number = 3.5 * 1000 * 1000;

    @Input() form: UntypedFormGroup;
    @Input() mode: 'add' | 'edit' = 'edit';
    @Output() saved: EventEmitter<{ form: UntypedFormGroup, file?: File }> = new EventEmitter<{ form: UntypedFormGroup, file?: File }>();
    @Output() canceled: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('fileUpload') fileUpload: FileUpload;
    file: File;

    chooseFile() {
        this.fileUpload.advancedFileInput?.nativeElement.click();
    }

    onSelect(event: { files: File[] }) {
        const file = event.files[0];
        if (!this.validateFile(file)) {
            return;
        }
        this.file = file;
        this.fileUpload.clear();
    }

    save() {
        this.saved.emit({form: this.form, file: this.file});
    }

    validateFile(file: File) {
        if (file.size > this.maxFileSize) {
            alert(`Datei darf nicht grösser als 3.5 MB sein.`);
            return false;
        }

        if (this.disallowedContentTypes.includes(file.type)) {
            alert(`Binary Dateien sind nicht erlaubt.`);
            return false;
        }

        return true;
    }
}
